import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { OneTimerTask } from '../types';

interface Props {
  task: OneTimerTask;
  onEdit: () => void;
  onDelete: () => void;
  onUndo?: () => void;
}

const TaskCardMenu: React.FC<Props> = ({ task, onEdit, onDelete, onUndo }) => {
  return (
    <Menu as="div" className="relative">
      <MenuButton className="p-1 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md">
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
        </svg>
      </MenuButton>

      <MenuItems className="absolute right-0 top-8 w-32 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-50">
        {task.isDone && onUndo && (
          <MenuItem>
            {({ focus }) => (
              <button
                onClick={onUndo}
                className={`${
                  focus ? 'bg-gray-100' : ''
                } w-full text-left px-3 py-2 text-sm text-gray-700 flex items-center gap-2`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                </svg>
                Undo
              </button>
            )}
          </MenuItem>
        )}
        
        <MenuItem>
          {({ focus }) => (
            <button
              onClick={onEdit}
              className={`${
                focus ? 'bg-gray-100' : ''
              } w-full text-left px-3 py-2 text-sm text-gray-700 flex items-center gap-2`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Edit
            </button>
          )}
        </MenuItem>
        
        <MenuItem>
          {({ focus }) => (
            <button
              onClick={onDelete}
              className={`${
                focus ? 'bg-red-50 text-red-700' : 'text-red-600'
              } w-full text-left px-3 py-2 text-sm flex items-center gap-2`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </button>
          )}
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default TaskCardMenu; 